<template>
  <div>
    <NavBar />
    <h1>學生詳情</h1>
    <CourseStudentList :student="student" />
    <StudentCalendarView :student="student" />
    <StudentExamTable :student="student" />
  </div>
</template>

<script setup>
import NavBar from "../components/NavBar.vue";
import CourseStudentList from "../components/CourseStudentList.vue";
import StudentCalendarView from "../components/StudentCalendarView.vue";
import StudentExamTable from "../components/StudentExamTable.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useQuery } from "@vue/apollo-composable";
import { GET_STUDENT } from "../graphql/queries";

const route = useRoute();
const student_id = parseInt(route.params.id);

// Fetch student data
const { result } = useQuery(
  GET_STUDENT,
  { student_id },
  { 
    fetchPolicy: 'network-only',  // Child Student Form component could mutate the student object
  } 
);

// Computed student data
const student = computed(() => result.value?.student || {});
</script>